module.exports = __webpack_public_path__ + "static/media/gf_3.d3249856.jpg";